class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    // 新加
    this.recommendsVariantSelectInit();
    $('#CartDrawer-Overlay').click(() => {
      $('.cart-drawer-box').removeClass('active');
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('no-scroll');
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    if (!this.classList.contains('is-empty')) {
      $('.cart-recommendations-wrapper').show();
    }
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    // 新加
    document.body.classList.add('no-scroll');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    // 新加
    document.body.classList.remove('no-scroll');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  recommendsVariantSelectInit() {
    $('.cart-recommendations .product-recommend-item select').change(function () {
      $(this).find('option').removeAttr('selected');
      const selectedOption = $(this).find('option:selected');
      selectedOption.attr('selected', 'selected');

      const price = selectedOption.data('price');
      const compare_price = selectedOption.data('compare-price');
      const $productItem = $(this).closest('.product-recommend-item');
      const $productItemPrice = $productItem.find('.product-price .price');
      $productItemPrice.text(price);
      if (compare_price != 0) {
        $productItem.find('.product-price .compare-price').text(compare_price);
      } else {
        $productItem.find('.product-price .compare-price').text('');
      }

      const $variantInput = $(this).closest('.product-recommend-item').find('product-form input[name=id]');
      const selectedVariantId = selectedOption.val();
      $variantInput.val(selectedVariantId);
    });
  }
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    this.recommendsVariantSelectInit();
    // 更新 cart 图标
    const cartIcon = $('#cart-icon-bubble .icon');
    if (parsedState.item_count === 0) {
      cartIcon.html(`<svg aria-hidden="true" focusable="false" class="icon icon-cart" viewBox="0 0 36 36" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.9999 7.75C16.7573 7.75 15.7499 8.75736 15.7499 10V12.25H20.2499V10C20.2499 8.75736 19.2426 7.75 17.9999 7.75ZM21.7499 12.25V10C21.7499 7.92893 20.071 6.25 17.9999 6.25C15.9289 6.25 14.2499 7.92893 14.2499 10V12.25H11.9394C11.0153 12.25 10.2505 12.9685 10.1928 13.8908L9.31781 27.8908C9.25484 28.8983 10.055 29.75 11.0644 29.75H24.9355C25.9449 29.75 26.7451 28.8983 26.6821 27.8908L25.8071 13.8908C25.7494 12.9685 24.9846 12.25 24.0605 12.25H21.7499ZM11.9394 13.75C11.8074 13.75 11.6981 13.8526 11.6899 13.9844L10.8149 27.9844C10.8059 28.1283 10.9202 28.25 11.0644 28.25H24.9355C25.0797 28.25 25.194 28.1283 25.185 27.9844L24.31 13.9844C24.3018 13.8526 24.1925 13.75 24.0605 13.75H11.9394Z" fill="currentColor"/>
      </svg>`);
    } else {
      cartIcon.html(`<svg width="36" height="36" class="icon icon-cart" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0001 10C16.0001 8.89543 16.8955 8 18.0001 8C19.1047 8 20.0001 8.89543 20.0001 10V12H16.0001V10ZM22.0001 10V12H24.0606C25.1168 12 25.9909 12.8212 26.0567 13.8752L26.9317 27.8752C27.0037 29.0266 26.0893 30 24.9356 30H11.0645C9.91089 30 8.99647 29.0266 9.06843 27.8752L9.94343 13.8752C10.0093 12.8212 10.8834 12 11.9395 12H14.0001V10C14.0001 7.79086 15.7909 6 18.0001 6C20.2092 6 22.0001 7.79086 22.0001 10Z" fill="#FF2929"/>
      </svg>`);
    }
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.cart-wrapper',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-wrapper',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
